<div *ngIf="saleChecked" class="MakeSalePanel apptBookerComponent">
    <div class="msLeft">
        <div class="invoiceList">
            <div style="display: flex; flex-direction: row; justify-content: space-around;">
              <dx-button (onClick)="focusAddProduct()" [focusStateEnabled]="false" style="margin:0px 4px 0px 0px"
                hint="Scan">
                <span class="material-icons">
                    barcode_reader
                </span>
              </dx-button>
              <app-add-product
                [ProductList]="ProductList"
                (onProductSelected)="onProductSelected($event)"
                (onProductInputValueChanged)="onProductInputValueChanged($event)"
                style="flex: 50%; flex-grow: 1; min-height: 100%"
              >
              </app-add-product>
                &nbsp;
                <dx-autocomplete #ctlAddCourse style="margin-left:5px!important; flex:50%;" placeholder="Add Course"
                    style="flex-grow: 1;" [dataSource]="CoursesList" [showClearButton]="true" valueExpr="CourseName"
                    showDropDownButton="true" openOnFieldClick="true" (onItemClick)="onCourseChanged($event)"
                    maxItemCount="500" searchExpr="CourseName" minSearchLength="0" itemTemplate="full"
                    [visible]="!allowSaleOfCourses" [dropDownOptions]="{ width: '200%' }">
                    <div *dxTemplate="let c of 'full'"
                        style="display:flex; flex-direction: row; justify-content: flex-end;">
                        <div style="flex:1 1; overflow-x: hidden; text-overflow: ellipsis;">
                            {{c.CourseName}}
                        </div>
                        <div>
                            {{c.Price | currency:'GBP':'symbol':'1.2-2' }}
                        </div>
                    </div>
                </dx-autocomplete>
            </div>

            <dx-list [dataSource]="this.invoiceItems" class="invoice" height="100%" style="flex:1 1; max-height:200px;"
                [focusStateEnabled]="false">
                <div *dxTemplate="let item of 'item'" style="padding:0px;">
                    <div class="saleItem">
                        <div class="productQty" *ngIf="item.SaleItemType<80">{{item.Qty}}x</div>
                        <div class="productQty" *ngIf="item.SaleItemType>=80"></div>
                        <div class="productDesc">
                            <div class="productName truncate" [title]="item.Description">{{item.Description}}</div>
                            <div *ngIf="item.IsVoucher" class="voucher truncate" [title]="item.VoucherCode">{{item.VoucherCode}}</div>
                            <div *ngIf="item.Discount>0" class="discountApplied truncate" title="Client discount applied">
                                Discount Applied : {{item.Discount |currency:'GBP':'symbol':'1.2-2'}}
                            </div>
                            <div *ngIf="item.DepositPaid > 0" class="discountApplied truncate" title="Client depsoit paid">
                                Deposit Paid : {{item.DepositPaid | currency:'GBP':'symbol':'1.2-2'}}
                            </div>
                        </div>
                        <div *ngIf="item.SaleItemType!=100" class="price"
                            title="Price to pay after discounts have been applied">{{item.Price |
                            currency:'GBP':'symbol':'1.2-2'}}</div>
                        <div *ngIf="item.SaleItemType==100" class="creditsTendered">{{item.CreditsUsed}}</div>

                        <div class="buttons">
                            <!-- Do not edit tender items or vouchers if not admin -->
                            <dx-button [disabled]="(item.SaleItemType>=80) || (!isAdmin && !hasCanEditPricesPrivs) || (item.IsVoucher)"
                                (onClick)="editSaleItem($event, item)" [focusStateEnabled]="false" style="margin:3px"
                                hint="Edit sale item">
                                <span class="material-icons">
                                    edit
                                </span>
                            </dx-button>

                            <dx-button [disabled]="item.SaleItemType==3 || item.SaleItemType==100"
                                (onClick)="deleteItem($event, item)" [focusStateEnabled]="false" style="margin: 3px 0px 3px 3px"
                                hint="Remove item from sale">
                                <span class="material-icons">
                                    delete
                                </span>
                            </dx-button>
                        </div>
                    </div>
                </div>
            </dx-list>
            <!-- <div class="dx-field">
                <div class="dx-field-label">Use Credits</div>
                <div class="dx-field-value">
                    <dx-switch [value]="UseCredits" switchedOffText="No" switchedOnText="Yes"
                        (onValueChanged)="onUseCreditsChanged($event)">
                    </dx-switch>
                </div>
            </div> -->
        </div>
    </div>
    <div class="msRight">
        <dx-list [dataSource]="this.upperItems" height="55" style="flex:0 0;min-height: 55px;"
            [focusStateEnabled]="false">
            <div *dxTemplate="let item of 'item'" style="padding:0px;">
                <div class="saleItem">
                    <div class="billDesc">{{item.Description}}</div>
                    <div class="billPrice">{{item.Price | currency:'GBP':'symbol':'1.2-2'}}</div>
                </div>
            </div>
        </dx-list>

        <div style="padding: 10px 0px; margin: 0 -5px; display: flex; flex-direction: row;">
            <dx-number-box #tenderAmount style="padding:10px 5px; margin: 0px 5px;" width="200"
                [value]='this.tenderAmountValue' placeholder="Tender Amount" format="£ #0.00" [mode]="'number'"
                [min]="0.0" [max]="999.99" (onInput)="onTenderValueChanged($event)">
            </dx-number-box>

            <dx-button (onClick)="btnTender($event, 'cash')" [focusStateEnabled]="false" hint="Tender cash"
                [disabled]="(this.tenderAmountValue==0 || outstandingBalance==0)">
                <span class="material-icons tenderButton" style="font-weight: bold; margin-top:-10px!important;">
                    £
                </span>
            </dx-button>           
            <dx-button *ngIf="!hasPayPoint" (onClick)="btnTender($event, 'creditcard')" [focusStateEnabled]="false" hint="Tender a card"
                [disabled]="(tenderAmountValue==0 || tenderAmountValue>outstandingBalance)">
                <span class="material-icons tenderButton">
                    credit_card
                </span>
            </dx-button>
            <dx-drop-down-button *ngIf="hasPayPoint" (onButtonClick)="onItemClick($event)" (onItemClick)="btnTender($event, 'creditcard')" 
                [focusStateEnabled]="false" hint="Tender a card" [splitButton]="true" [useSelectMode]="false" 
                [items]="creditCardOptions" displayExpr="name" keyExpr="id" icon="material-icons dx-icon-mdCreditCard"
                [dropDownOptions]="{minWidth: 110}"
                [disabled]="(tenderAmountValue==0 || tenderAmountValue>outstandingBalance)">
                <span class="material-icons tenderButton">
                    credit_card
                </span>
            </dx-drop-down-button>
            <dx-button *ngIf="FFVouchers==true" (onClick)="btnTender($event, 'voucher')" [focusStateEnabled]="false" hint="Tender a voucher"
                [disabled]="(tenderAmountValue==0 || tenderAmountValue>outstandingBalance)">
                <span class="material-icons tenderButton">
                    redeem
                </span>
            </dx-button>
            <dx-button style="padding:0px 5px;margin: 0px 5px;" text="O/B" hint="Get outstanding balance"
                [disabled]="this.outstandingBalance==0" (onClick)="btnOutstandingBalance($event)">
            </dx-button>
        </div>

        <dx-list [dataSource]="this.lowerItems" height="75" style="flex:0 0;min-height: 75px;"
            [focusStateEnabled]="false">
            <div *dxTemplate="let item of 'item'" style="padding:0px;">
                <div class="saleItem">
                    <div class="billDesc">{{item.Description}}</div>
                    <div class="billPrice">{{item.Price | currency:'GBP':'symbol':'1.2-2'}}</div>
                </div>
            </div>
        </dx-list>

        <div style="padding: 0px; margin: 0px -5px; display: flex; flex-direction: row; flex-wrap: wrap;justify-content: flex-end;">
            <dx-button #btnMakeSaleCtl
                style="flex: 30%; padding:10px 5px 10px 5px; margin:10px 15px 0px 0px; background-color: var(--main_button-color); color:var(--main_button-text-color); font-size: 20px; font-weight: bold; max-width: 200px;min-width: 120px; max-height: 59px; min-height: 59px;"
                text="Make Sale" title="Process the sale" (onClick)="btnMakeSale($event)" [disabled]="disableMakeSale">
            </dx-button>
            <dx-button #btnBookAptCtl
                style="flex: 30%; padding:10px 10px 10px 10px; margin:10px 0px 0px 15px; font-size: 20px; font-weight: bold; max-width: 200px; min-width: 120px; max-height: 59px; min-height: 59px;"
                text="Book" title="Book Appointment" [visible]="(AllowBooking && !showCancelButton) || showPaymentAfterSessionBookApt"
                (onClick)="btnBookApt($event)" [disabled]="disableBookApt && !showPaymentAfterSessionBookApt">
            </dx-button>

            <dx-button #btnCancelCtl
                style="flex: 30%; padding:10px 10px 10px 10px; margin:10px 15px 0px 15px; font-size: 20px; font-weight: bold; max-width: 200px;min-width: 120px; max-height: 59px; min-height: 59px;"
                text="Cancel" title="Cancel" [visible]="showCancelButton" (onClick)="btnCancel($event)">
            </dx-button>

            <dx-button #btnNoSaleCtl
                style="flex: 30%; padding:10px 10px 10px 10px; margin:10px 15px 0px 15px; font-size: 20px; font-weight: bold; max-width: 200px;min-width: 120px; max-height: 59px; min-height: 59px;"
                text="No Sale" title="No Sale" [visible]="showNoSaleButton" (onClick)="btnNoSale($event)">
            </dx-button>
        </div>
    </div>
</div>

<app-sale-item-editor (CloseDlg)="onCloseSaleItemDlg($event)"></app-sale-item-editor>
<app-disclaimer (CloseDlg)="DisclaimerDlgClosed($event)"></app-disclaimer>
<app-credits-calculator (CloseDlg)="CreditsCalculatorDlgClosed($event)"></app-credits-calculator>
<app-voucher-code (CloseDlg)="VoucherCodeDlgClosed($event)"></app-voucher-code>
<app-voucher-tender (CloseDlg)="TenderVoucherDlgClosed($event)"></app-voucher-tender>